module.exports = __webpack_public_path__ + "img/bg_aboutItem_1.12acc831.png";